import About from "../components/Sections/About";
import AntiSlaveryPolicy from "../components/Sections/AntiSlaveryPolicy";
import Contact from "../components/Sections/Contact";

export default function AntiSlaveryPage() {
//   return < AboutBanner/>
  return (
    <>
        {/* <Contact /> */}
        <AntiSlaveryPolicy />


    </>
  );
}
